/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { UtilisateurDto } from '../models/utilisateur-dto';


/**
 * Fonctions de gestion des utilisateurs
 */
@Injectable({
  providedIn: 'root',
})
export class UtilisateursService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation utilisateurGetList
   */
  static readonly UtilisateurGetListPath = '/api/utilisateurs/list';

  /**
   * Renvoie la liste des utilisateurs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<UtilisateurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UtilisateurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des utilisateurs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGetList(params?: {
  }): Observable<Array<UtilisateurDto>> {

    return this.utilisateurGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UtilisateurDto>>) => r.body as Array<UtilisateurDto>)
    );
  }

  /**
   * Path part for operation utilisateurGetListEc
   */
  static readonly UtilisateurGetListEcPath = '/api/utilisateurs/listEC';

  /**
   * Renvoie la liste des utilisateurs de l'EC (rapport incident).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurGetListEc()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGetListEc$Response(params?: {
  }): Observable<StrictHttpResponse<Array<UtilisateurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurGetListEcPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UtilisateurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des utilisateurs de l'EC (rapport incident).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurGetListEc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGetListEc(params?: {
  }): Observable<Array<UtilisateurDto>> {

    return this.utilisateurGetListEc$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UtilisateurDto>>) => r.body as Array<UtilisateurDto>)
    );
  }

  /**
   * Path part for operation utilisateurLoadList
   */
  static readonly UtilisateurLoadListPath = '/api/utilisateurs/load-list';

  /**
   * Renvoie la liste des utilisateurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des utilisateurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.utilisateurLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation utilisateurGet
   */
  static readonly UtilisateurGetPath = '/api/utilisateurs/{id}';

  /**
   * Renvoie l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGet$Response(params: {

    /**
     * Identifiant de l&#x27;utilisateur
     */
    id: number;
  }): Observable<StrictHttpResponse<UtilisateurDto>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UtilisateurDto>;
      })
    );
  }

  /**
   * Renvoie l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGet(params: {

    /**
     * Identifiant de l&#x27;utilisateur
     */
    id: number;
  }): Observable<UtilisateurDto> {

    return this.utilisateurGet$Response(params).pipe(
      map((r: StrictHttpResponse<UtilisateurDto>) => r.body as UtilisateurDto)
    );
  }

  /**
   * Path part for operation utilisateurPut
   */
  static readonly UtilisateurPutPath = '/api/utilisateurs/{id}';

  /**
   * Met à jour l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurPut$Response(params: {

    /**
     * Identifiant de l&#x27;utilisateur à mettre à jour
     */
    id: number;

    /**
     * Utilisateur
     */
    body: UtilisateurDto
  }): Observable<StrictHttpResponse<UtilisateurDto>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UtilisateurDto>;
      })
    );
  }

  /**
   * Met à jour l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurPut(params: {

    /**
     * Identifiant de l&#x27;utilisateur à mettre à jour
     */
    id: number;

    /**
     * Utilisateur
     */
    body: UtilisateurDto
  }): Observable<UtilisateurDto> {

    return this.utilisateurPut$Response(params).pipe(
      map((r: StrictHttpResponse<UtilisateurDto>) => r.body as UtilisateurDto)
    );
  }

  /**
   * Path part for operation utilisateurDelete
   */
  static readonly UtilisateurDeletePath = '/api/utilisateurs/{id}';

  /**
   * Supprime l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurDelete$Response(params: {

    /**
     * Identifiant de l&#x27;utilisateur à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurDelete(params: {

    /**
     * Identifiant de l&#x27;utilisateur à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.utilisateurDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation utilisateurPost
   */
  static readonly UtilisateurPostPath = '/api/utilisateurs';

  /**
   * Crée l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurPost$Response(params: {

    /**
     * Utilisateur
     */
    body: UtilisateurDto
  }): Observable<StrictHttpResponse<UtilisateurDto>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UtilisateurDto>;
      })
    );
  }

  /**
   * Crée l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurPost(params: {

    /**
     * Utilisateur
     */
    body: UtilisateurDto
  }): Observable<UtilisateurDto> {

    return this.utilisateurPost$Response(params).pipe(
      map((r: StrictHttpResponse<UtilisateurDto>) => r.body as UtilisateurDto)
    );
  }

  /**
   * Path part for operation utilisateurPutDetail
   */
  static readonly UtilisateurPutDetailPath = '/api/utilisateurs/{id}/detail';

  /**
   * Met à jour l'utilisateur spécifié (détail).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurPutDetail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurPutDetail$Response(params: {

    /**
     * Identifiant de l&#x27;utilisateur à mettre à jour
     */
    id: number;

    /**
     * Utilisateur
     */
    body: UtilisateurDto
  }): Observable<StrictHttpResponse<UtilisateurDto>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurPutDetailPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UtilisateurDto>;
      })
    );
  }

  /**
   * Met à jour l'utilisateur spécifié (détail).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurPutDetail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurPutDetail(params: {

    /**
     * Identifiant de l&#x27;utilisateur à mettre à jour
     */
    id: number;

    /**
     * Utilisateur
     */
    body: UtilisateurDto
  }): Observable<UtilisateurDto> {

    return this.utilisateurPutDetail$Response(params).pipe(
      map((r: StrictHttpResponse<UtilisateurDto>) => r.body as UtilisateurDto)
    );
  }

  /**
   * Path part for operation utilisateurSetActif
   */
  static readonly UtilisateurSetActifPath = '/api/utilisateurs/{id}/actif';

  /**
   * Met à jour le statut actif de l'utilisateur spécifié (détail).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurSetActif()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurSetActif$Response(params: {

    /**
     * Identifiant de l&#x27;utilisateur à mettre à jour
     */
    id: number;

    /**
     * Statut actif de l'utilisateur
     */
    body: boolean
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurSetActifPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Met à jour le statut actif de l'utilisateur spécifié (détail).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurSetActif$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurSetActif(params: {

    /**
     * Identifiant de l&#x27;utilisateur à mettre à jour
     */
    id: number;

    /**
     * Statut actif de l'utilisateur
     */
    body: boolean
  }): Observable<boolean> {

    return this.utilisateurSetActif$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation utilisateurDesactivate
   */
  static readonly UtilisateurDesactivatePath = '/api/utilisateurs/{id}/desactivate';

  /**
   * Désactive l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurDesactivate$Response(params: {

    /**
     * Identifiant de l&#x27;utilisateur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: UtilisateurDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  utilisateurDesactivate(params: {

    /**
     * Identifiant de l&#x27;utilisateur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: UtilisateurDto
  }): Observable<number> {

    return this.utilisateurDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation utilisateurGetByReference
   */
  static readonly UtilisateurGetByReferencePath = '/api/utilisateurs/reference/{reference}';

  /**
   * Renvoie l'utilisateur recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `utilisateurGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<UtilisateurDto>> {

    const rb = new RequestBuilder(this.rootUrl, UtilisateursService.UtilisateurGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UtilisateurDto>;
      })
    );
  }

  /**
   * Renvoie l'utilisateur recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `utilisateurGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  utilisateurGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<UtilisateurDto> {

    return this.utilisateurGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<UtilisateurDto>) => r.body as UtilisateurDto)
    );
  }

}
